import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ForgetPassswordService} from "../../../services/forget-passsword.service";
import {StorageService} from "../../../services/storage.service";

@Component({
  selector: 'app-verify-phone',
  templateUrl: './verify-phone.component.html',
  styleUrl: './verify-phone.component.scss'
})
export class VerifyPhoneComponent implements OnInit, OnDestroy {

  otpForm: FormGroup;
  errorMessage = '';
  type: string;
  timer: number = 0; // Timer in seconds
  interval: any; // Reference to the timer interval
  isTimerExpired: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly forgotPasswordService: ForgetPassswordService,
    private readonly cdr: ChangeDetectorRef,
    private readonly storageService: StorageService,
  ) {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required]],
    });
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
  }

  ngOnInit() {
    this.initializeTimer();
  }

  ngOnDestroy() {
    // Clear interval on destroy
    clearInterval(this.interval);
  }

  initializeTimer() {
    const currentTime = Date.now();
    const expirationTime = +this.storageService.getItem('otpExpirationTime') || 0;

    if (expirationTime && currentTime < expirationTime) {
      this.timer = Math.floor((expirationTime - currentTime) / 1000);
      this.isTimerExpired = false;
      this.startTimer();
    } else {
      this.isTimerExpired = true;
      this.storageService.setItem('otpExpirationTime', null); // Clear expired time
    }
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
        this.cdr.detectChanges(); // Trigger change detection
      } else {
        this.isTimerExpired = true;
        clearInterval(this.interval);
        this.storageService.setItem('otpExpirationTime', null); // Clear expiration time
        this.cdr.detectChanges(); // Trigger change detection after expiry
      }
    }, 1000);
  }

  resetTimer() {
    clearInterval(this.interval);
    const expirationTime = Date.now() + 300 * 1000; // Set expiration time to 5 minutes from now
    this.storageService.setItem('otpExpirationTime', expirationTime.toString());
    this.timer = 300;
    this.isTimerExpired = false;
    this.startTimer();
    this.resetOtp();
  }

  resetOtp() {
    this.forgotPasswordService.citizenVerifyPhoneNumber(this.activatedRoute.snapshot.paramMap.get('number')).subscribe({
      next: (response: any) => {
        // Handle response if needed
      },
      error: (err) => {
        console.error('Error during OTP reset:', err);
      }
    });
  }

  verifyOtp(formData: any) {
    this.forgotPasswordService.citizenVerifyOtpNumber(formData.otp).subscribe({
      next: (response: any) => {
        const isSuccessful = response?.response?.status;
        if (isSuccessful) {
          let number = this.activatedRoute.snapshot.paramMap.get('number')
          this.router.navigate([`/reset-password/phone/${number}`]);
        } else {
          this.errorMessage = 'Failed to verify OTP';
        }
      },
      error: (err) => {
        this.errorMessage = 'Error during verification. Please try again.';
        console.error('Error during verification:', err);
      }
    });
  }

  get formattedTime(): string {
    const minutes = Math.floor(this.timer / 60);
    const seconds = this.timer % 60;
    return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }
}
